(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alman-announcement"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-alman-announcement-close]');
    if (!button) return;
    const announcement = button.closest('.alman-announcement');
    if (announcement) announcement.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alman-product-layout"] && !Shopify.designMode) return;
  try {
    
  class AlmanProductDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-alman-drawer-close]');
      this.details = document.querySelector(
        "[data-testid='product-information'] .product-details .accordion details[data-testid='accordion-details']"
      );
      this.trigger = this.details?.querySelector('summary');

      this.positionPurchaseBenefits();
      this.productInformation = document.querySelector("[data-testid='product-information']");
      this.imageData = document.querySelector('[data-alman-variant-image-data]');
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.enhanceVariantImages();

      if (this.productInformation && this.imageData) {
        this.productInformation.addEventListener('change', this.handleVariantChange);
        this.variantObserver = new MutationObserver(() => {
          window.requestAnimationFrame(() => this.enhanceVariantImages());
        });
        this.variantObserver.observe(this.productInformation, { childList: true, subtree: true });
      }

      if (document.querySelector('alman-product-information') || !this.dialog || !this.trigger) return;

      this.trigger.classList.add('alman-details-trigger');
      this.details.removeAttribute('open');

      const summaryText = this.dataset.summary;
      if (summaryText) {
        const preview = document.createElement('span');
        preview.className = 'alman-details-trigger__preview';
        preview.textContent = summaryText;
        this.trigger.append(preview);
      }

      const more = document.createElement('span');
      more.className = 'alman-details-trigger__more';
      more.textContent = 'Ver mais';
      this.trigger.append(more);

      this.openDrawer = this.openDrawer.bind(this);
      this.closeDrawer = this.closeDrawer.bind(this);
      this.handleBackdrop = this.handleBackdrop.bind(this);

      this.trigger.addEventListener('click', this.openDrawer);
      this.closeButton?.addEventListener('click', this.closeDrawer);
      this.dialog.addEventListener('click', this.handleBackdrop);
      this.dialog.addEventListener('close', this.unlockPage);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.openDrawer);
      this.closeButton?.removeEventListener('click', this.closeDrawer);
      this.dialog?.removeEventListener('click', this.handleBackdrop);
      this.dialog?.removeEventListener('close', this.unlockPage);
      this.productInformation?.removeEventListener('change', this.handleVariantChange);
      this.variantObserver?.disconnect();
    }

    positionPurchaseBenefits() {
      const benefits = document.querySelector('[data-alman-purchase-benefits]');
      const addButton = document.querySelector("[data-testid='product-information'] .add-to-cart-button");
      if (!benefits || !addButton) return;

      const purchaseArea = addButton.closest('buy-buttons, .product-form-buttons, .product-form__buttons');
      if (purchaseArea) {
        purchaseArea.insertAdjacentElement('afterend', benefits);
      } else {
        addButton.insertAdjacentElement('afterend', benefits);
      }
      benefits.hidden = false;
      const information = document.querySelector('alman-product-information');
      if (information && benefits.previousElementSibling !== information) {
        benefits.insertAdjacentElement('beforebegin', information);
        information.hidden = false;
      }
    }

    enhanceVariantImages() {
      if (!this.imageData || !this.productInformation) return;

      this.imageData.querySelectorAll('[data-alman-option-image]').forEach((item) => {
        const optionValue = item.dataset.almanOptionValue;
        const imageUrl = item.dataset.almanOptionImage;
        const inputs = this.productInformation.querySelectorAll("input[type='radio'][value]");
        const matchingInput = Array.from(inputs).find((input) => input.value === optionValue);
        if (!matchingInput || !imageUrl) return;

        const escapedId = CSS.escape(matchingInput.id);
        const label = this.productInformation.querySelector(`label[for='${escapedId}']`) || matchingInput.closest('label');
        if (!label) return;

        label.classList.add('alman-variant-thumbnail');
        label.style.setProperty('--alman-variant-image', `url("${imageUrl}")`);
        label.setAttribute('aria-label', optionValue);
        label.classList.toggle('is-selected', matchingInput.checked);
      });
    }

    handleVariantChange() {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => this.enhanceVariantImages());
      });
    }

    openDrawer(event) {
      event?.preventDefault();
      this.details?.removeAttribute('open');
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.setAttribute('scroll-lock', '');
    }

    closeDrawer() {
      if (this.dialog.open) this.dialog.close();
    }

    handleBackdrop(event) {
      if (event.target === this.dialog) this.closeDrawer();
    }

    unlockPage = () => {
      document.documentElement.removeAttribute('scroll-lock');
    };
  }

  if (!customElements.get('alman-product-drawer')) {
    customElements.define('alman-product-drawer', AlmanProductDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
